/** Classify the properties search box input as postcode area vs full address. */
const FULL_POSTCODE = /^[A-Z]{1,2}\d[A-Z\d]?\s+\d[A-Z]{2}$/i;
const OUTWARD_ONLY = /^[A-Z]{1,2}\d[A-Z\d]?$/i;
const AREA_PREFIX = /^[A-Z]{1,2}$/i;

export function classifySearchInput(raw) {
  const text = raw.trim();
  if (!text) return 'postcode';

  const compact = text.replace(/\s+/g, ' ').toUpperCase();

  if (FULL_POSTCODE.test(compact) || OUTWARD_ONLY.test(compact) || AREA_PREFIX.test(compact)) {
    return 'postcode';
  }

  // Street number, commas, or several words → treat as address lookup
  if (/^\d+[A-Z]?\s/i.test(text) || text.includes(',') || text.split(/\s+/).length >= 3) {
    return 'address';
  }

  return 'postcode';
}

export function extractUkPostcode(text) {
  const match = text.toUpperCase().match(/[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}/);
  if (!match) return null;
  const clean = match[0].replace(/\s+/, '');
  return `${clean.slice(0, -3)} ${clean.slice(-3)}`;
}

/** Only commit the search box when the input is complete enough to search. */
export function shouldCommitSearchInput(raw) {
  const text = raw.trim();
  if (!text) return false;
  if (classifySearchInput(text) === 'postcode') return true;
  return !!extractUkPostcode(text);
}
